import * as React from 'react';
import { MergeStylesShadowRootContext } from '../contexts/MergeStylesShadowRootContext';
/**
 * Test if a context is available.
 * @returns true if there is a context.
 */
export var useHasMergeStylesShadowRootContext = function () {
  return !!useMergeStylesShadowRootContext();
};
/**
 * Get a reference to the shadow root context.
 * @returns The context for the shadow root.
 */
export var useMergeStylesShadowRootContext = function () {
  return React.useContext(MergeStylesShadowRootContext);
};
//# sourceMappingURL=useMergeStylesShadowRoot.js.map